import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=b23966c8&scoped=true&"
import script from "./CompanyProfile.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=b23966c8&scoped=true&lang=css&"
import style1 from "./CompanyProfile.vue?vue&type=style&index=1&id=b23966c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23966c8",
  null
  
)

export default component.exports